// Widget CSS
import '@/css/_elementor/widgets/tabs_widget.css';

// ..........................................................................................
// ..........................................................................................

// Hook into Elementor frontend init
window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/tabs_widget.default', (scope) => {
		const scopeEl = scope[0];
		// ......

		document.addEventListener('click', (e) => {
			const btn = e.target.closest('.tab-nav-item');
			if (!btn) return;

			const wrapper = btn.closest('.tabs-widget');
			const id = btn.dataset.tab;

			wrapper.querySelectorAll('.tab-nav-item').forEach((el) => el.classList.remove('is-active'));
			wrapper.querySelectorAll('.tab-panel').forEach((el) => el.classList.remove('is-active'));

			btn.classList.add('is-active');
			wrapper.querySelector(`[data-tab-content="${id}"]`).classList.add('is-active');
		});

		// ......

		const tabsNav = scopeEl.querySelector('.tabs-nav');
		const tabsNavInner = scopeEl.querySelector('.tabs-nav-inner');
		const tabs = tabsNav.querySelectorAll('.tab-nav-item');
		const bg = tabsNav.querySelector('.tabs-nav_bg');

		function moveBg(tab) {
			if (!tab) return;

			const rect = tab.getBoundingClientRect();
			const parentRect = tabsNavInner.getBoundingClientRect();

			const top = rect.top - parentRect.top;
			const left = rect.left - parentRect.left;

			bg.style.width = rect.width + 'px';
			bg.style.height = rect.height + 'px';
			bg.style.transform = `translate(${left}px, ${top}px)`;
		}

		function moveToActive() {
			const activeTab = tabsNav.querySelector('.tab-nav-item.is-active');
			moveBg(activeTab);
		}

		// ...

		tabs.forEach((tab) => {
			tab.addEventListener('mouseenter', () => moveBg(tab));
		});

		tabsNav.addEventListener('mouseleave', moveToActive);

		// ...

		// run after layout stabilizes
		window.addEventListener('load', moveToActive);

		// recalc on resize
		const resizeObserver = new ResizeObserver(() => moveToActive());
		resizeObserver.observe(tabsNav);

		// recalc after fonts load
		if (document.fonts) {
			document.fonts.ready.then(moveToActive);
		}

		// ......
	});
});

// ..........................................................................................
